import type { IconComponent } from '@components/icons/types'

/** Arrow pointing to top-right (↗) Symbol */
export const Arrow: IconComponent = ({
    width = '16',
    height = '16',
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...restOfProps}
    >
        <path
            d='M0 1H15M15 1V16M15 1L1 15'
            stroke='currentColor'
            strokeWidth='2'
        />
    </svg>
)
